// pages/QuestionnaireAGAMale.tsx
import QuestionnaireForm from '../components/QuestionnaireForm';
const QuestionnaireAGAMale = () => (
  <QuestionnaireForm questionFile="agamale_questions.json" service="aga_male" />
);
export default QuestionnaireAGAMale;